import {Button} from "@mui/material";
import React from "react";
import {Link as RouterLink} from "react-router-dom";
import {useLocalization} from "../../i18n";

export function BookABoxCta({tenantId, siteId}: { tenantId: string; siteId: string }) {
	const {t} = useLocalization();
	return (
		<Button
			fullWidth
			size="large"
			variant="outlined"
			color="primary"
			component={RouterLink}
			to={`/${tenantId}/${siteId}`}
		>
			{t("storefront.bookCta")}
		</Button>
	);
}
